<template>
  <div class="container-fluid" id="intro">
    <div class="row wrapper">
      <div class="col-12 col-md-4">
        <div class="header">
          <h2 class="mt-2 mb-1">&nbsp;</h2>
          <div class="hero-image" alt="Your insurance needs"></div>
        </div>
      </div>
      <div class="col-12 col-md-8">
        <div class="main">
          <h1 tabindex="0">Limitations of the calculator</h1>

          <small role="document">
              This calculator assesses insurance needs based on the limited information you enter, and the assumptions built within the tool.
              The calculator does not take all your financial needs into account, does not evaluate whether you are eligible for insurance
              and does not consider the appropriateness of holding cover inside or outside of super or whether you can afford the estimated insurance cover.
              <br /><br />
              The calculator is built for illustrative purposes only, is not a recommendation or a quote and should not be relied on for the purposes
              of making decisions in relation to a financial product. The calculated cover does not consider any existing cover you might have,
              whether held outside or inside superannuation. Please note, large or multiple amounts of insurance cover may erode your retirement income.
              <br /><br />
              The estimates provided by the calculator may differ if your circumstances change or if there are legislative changes.
              The amount of suggested cover will typically be less than your current income and may not be enough to cover all the responsibilities you select.
              <br /><br />
              You should reassess your insurance needs regularly as your circumstances may change. You should consider obtaining professional advice from
              a licensed financial <span v-html="pageContent.pages.limitations.preferredTerminology"></span> before making any decisions about your insurance.
              <br /><br />
              <span v-html="pageContent.pages.limitations.lastUpdated"></span>
          </small>

          <div class="nav-button row mt-4 mb-4">
            <router-link class="next-button col ml-0" to="/about" tabindex="0" role="button">Continue</router-link>
          </div>
        </div>


      </div>
    </div>
    <CustomFooter></CustomFooter>
  </div>
</template>

<script>

import CustomFooter from '../components/CustomFooter';
import { mapGetters } from 'vuex';

export default {
  name: 'Intro',
  components: {CustomFooter},
  computed: {
    ...mapGetters(["pageContent"]),
  },
  mounted() {
    this.$refreshIframeHeight();
    this.$scrollIframeTop();
    window.addEventListener("resize", this.$refreshIframeHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.$refreshIframeHeight);
  }
};
</script>
